/**
 * Certified IP CTS mode flag (FCC roadmap Sprint 1).
 *
 * Lives apart from ./functions.ts on purpose: that module imports
 * react-native, which the web jest environment cannot load, and caption
 * preference logic needs this flag in both environments. This reads the two
 * documented runtime config sources directly:
 *   - web:    window.__WHITELABEL__ injected by whitelabel-runtime.js
 *   - native: the tenant config cached under `vrs_tenant_config`
 *
 * FAIL-CLOSED by design: certification mode changes regulated behavior
 * (expressive captions disabled, demo accounts blocked, eligibility notices
 * shown), so an absent or malformed flag always means "not certified".
 */
import { getPersistentJson } from '../../vrs-auth/storage';
function getRuntimeWhitelabelSlice() {
    const fromGlobal = globalThis.__WHITELABEL__;
    if (fromGlobal) {
        return fromGlobal;
    }
    return getPersistentJson('vrs_tenant_config') || undefined;
}
/**
 * Whether the current tenant runs in FCC-certified IP CTS mode.
 */
export function isCertifiedIpCtsEnabled() {
    const val = getRuntimeWhitelabelSlice()?.features?.certifiedIpCts;
    if (typeof val === 'boolean') {
        return val;
    }
    return val?.enabled === true;
}
